import { render, staticRenderFns } from "./MeetingDocument.vue?vue&type=template&id=55df4672"
import script from "./MeetingDocument.vue?vue&type=script&lang=js"
export * from "./MeetingDocument.vue?vue&type=script&lang=js"
import style0 from "./MeetingDocument.vue?vue&type=style&index=0&id=55df4672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports